import { useQuery } from "@tanstack/react-query"
import { getUrl } from "aws-amplify/storage"

export const useUrlImageQuery = (path: string) => {
  const { isPending, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [`urlImage`, path],
    queryFn: async () => {
      if (path === "") return ""
      const imagePath = path?.startsWith("https://")
        ? path.split("amazonaws.com/").pop()
        : path

      const { url } = await getUrl({
        path: imagePath || "",
        options: {
          validateObjectExistence: true,
          expiresIn: 3600,
        },
      })
      return url.toString()
    },
  })
  return {
    pendingUrlImage: isPending,
    errorUrlImage: isError,
    successUrlImage: isSuccess,
    refetchUrlImage: refetch,
    urlImage: data as string,
  }
}
